__turbopack_context__.v({
  "seo-content": "index-module-scss-module__FOXd_a__seo-content",
});
